






























































































































import Vue from "vue";

// Model
import { formatCurrency } from "@/utility/Formatter.js";

export default Vue.extend({
    data() {
        return {
            search: "",
            headers: [
                { text: this.$t("usersBalance.cashIn"), value: "cashIn", sortable: false },
                { text: this.$t("usersBalance.cashOut"), value: "cashOut", sortable: false },
                { text: this.$t("usersBalance.cashBalance"), value: "cashBalance", sortable: false },
                { text: this.$t("usersBalance.manualDeposit"), value: "manualDeposit", sortable: false },
                { text: this.$t("usersBalance.balance"), value: "balance", sortable: false },
            ],
        };
    },
    props: {
        loading: { type: Boolean, default: false },
        usersBalanceReportEntries: { type: Array },
        isTotalsTable: { type: Boolean, default: false },
        analizedTransactionsCount: { type: Number },
    },
    computed: {
        computedHeaders() {
            let res = [];
            if (!this.isTotalsTable) {
                res.push({ text: this.$t("common.username"), value: "username" });
                res.push({ text: this.$t("common.userId"), value: "userId" });
            }
            this.headers.forEach((h) => {
                res.push(h);
            });
            if (!this.isTotalsTable) {
                res.push({ text: this.$t("usersBalance.kitWithdrawn"), value: "kitWithdrawn" });
                res.push({ text: this.$t("usersBalance.endShiftDeposited"), value: "endShiftDeposited" });
            }
            return res;
        },
    },
    methods: { formatCurrency },
});
